module.exports = __webpack_public_path__ + "static/img/kanban03.32d7953f.png";